import { useState } from "react";
import useReveal from "../hooks/useReveal";
import { GALLERY_CATEGORIES, GALLERY_ITEMS, BEFORE_AFTER } from "../lib/data";
import BeforeAfter from "../components/BeforeAfter";

export default function Gallery() {
  useReveal();
  const [filter, setFilter] = useState("all");
  const items = filter === "all" ? GALLERY_ITEMS : GALLERY_ITEMS.filter((g) => g.cat === filter);

  return (
    <div data-testid="gallery-page" className="pt-28 pb-24 bg-[#0B0B0B] text-white">
      <section className="px-6 md:px-12 py-16 text-center">
        <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">Gallery</span>
        <h1 className="font-display text-5xl md:text-6xl mt-5">Our Work</h1>
        <p className="text-white/65 max-w-2xl mx-auto mt-5 text-sm md:text-base">Explore transformations from our team — hover to peek behind the look.</p>
      </section>

      {/* Filter pills */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex gap-3 overflow-x-auto pb-3 -mx-1 px-1">
          {GALLERY_CATEGORIES.map((c) => (
            <button
              key={c.id}
              data-testid={`gallery-filter-${c.id}`}
              onClick={() => setFilter(c.id)}
              className={`tab-pill ${filter === c.id ? "active" : ""}`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-10">
          {items.map((g, i) => (
            <div key={`${g.src}-${i}`} data-testid={`gallery-item-${i}`} className="gallery-card aspect-[4/5] reveal" style={{ transitionDelay: `${i * 40}ms` }}>
              <img src={g.src} alt={g.title} className="w-full h-full object-cover" />
              <div className="overlay">
                <div>
                  <p className="text-[10px] tracking-[0.3em] uppercase text-[#C9A34E]">{GALLERY_CATEGORIES.find(c => c.id === g.cat)?.label}</p>
                  <p className="font-display text-lg text-white mt-1">{g.title}</p>
                </div>
              </div>
            </div>
          ))}
          {items.length === 0 && (
            <p className="col-span-full text-center text-white/50 py-16">No items in this category yet.</p>
          )}
        </div>

        {/* Before & After */}
        <section className="mt-24">
          <div className="text-center reveal">
            <span className="gold-divider text-[11px] tracking-[0.32em] uppercase">Transformations</span>
            <h2 className="font-display text-4xl md:text-5xl mt-5">Before & After</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            {BEFORE_AFTER.map((ba, i) => (
              <div key={ba.title} className="reveal" style={{ transitionDelay: `${i * 100}ms` }}>
                <BeforeAfter {...ba} />
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
